module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2zM14 23a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v10zm8 0a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/align-bottom-1.js
// module id = 981
// module chunks = 14